import gql from "graphql-tag"
import type { TypedDocumentNode } from "@graphql-typed-document-node/core"

type SearchOrderOperationsCountQuery = { searchOrderOperations: { total: number } }
type SearchOrderOperationsCountVariables = {
  from?: number | null
  size?: number | null
  query?: string | null
  sort?: Array<{ field: string; order: string }> | null
  trackTotalHits?: boolean | null
}

const SEARCH_ORDER_OPERATIONS_COUNT: TypedDocumentNode<
  SearchOrderOperationsCountQuery,
  SearchOrderOperationsCountVariables
> = gql`
  query searchOrderOperationsCount(
    $from: Int
    $size: Int
    $query: AWSJSON
    $sort: [SearchSorting!]
    $trackTotalHits: Boolean
  ) {
    searchOrderOperations(
      from: $from
      size: $size
      query: $query
      sort: $sort
      trackTotalHits: $trackTotalHits
    ) {
      total
    }
  }
`

export default SEARCH_ORDER_OPERATIONS_COUNT
